/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFZoomyDomainConfidenceMapList } from './CRSFZoomyDomainConfidenceMapList';
import {
    CRSFZoomyDomainConfidenceMapListFromJSON,
    CRSFZoomyDomainConfidenceMapListFromJSONTyped,
    CRSFZoomyDomainConfidenceMapListToJSON,
} from './CRSFZoomyDomainConfidenceMapList';

/**
 * 
 * @export
 * @interface CRSFDomainExpansionTicketData
 */
export interface CRSFDomainExpansionTicketData {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFDomainExpansionTicketData
     */
    account_removed_domains?: Array<string>;
    /**
     * 
     * @type {CRSFZoomyDomainConfidenceMapList}
     * @memberof CRSFDomainExpansionTicketData
     */
    domain_confidence_list?: CRSFZoomyDomainConfidenceMapList;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CRSFDomainExpansionTicketData
     */
    domain_sources?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFDomainExpansionTicketData
     */
    expansion_components?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFDomainExpansionTicketData
     */
    high_confidence_domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFDomainExpansionTicketData
     */
    invalid_input_domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFDomainExpansionTicketData
     */
    new_domains_at_bind?: Array<string>;
}

/**
 * Check if a given object implements the CRSFDomainExpansionTicketData interface.
 */
export function instanceOfCRSFDomainExpansionTicketData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFDomainExpansionTicketDataFromJSON(json: any): CRSFDomainExpansionTicketData {
    return CRSFDomainExpansionTicketDataFromJSONTyped(json, false);
}

export function CRSFDomainExpansionTicketDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainExpansionTicketData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account_removed_domains': !exists(json, 'account_removed_domains') ? undefined : json['account_removed_domains'],
        'domain_confidence_list': !exists(json, 'domain_confidence_list') ? undefined : CRSFZoomyDomainConfidenceMapListFromJSON(json['domain_confidence_list']),
        'domain_sources': !exists(json, 'domain_sources') ? undefined : json['domain_sources'],
        'expansion_components': !exists(json, 'expansion_components') ? undefined : json['expansion_components'],
        'high_confidence_domains': !exists(json, 'high_confidence_domains') ? undefined : json['high_confidence_domains'],
        'invalid_input_domains': !exists(json, 'invalid_input_domains') ? undefined : json['invalid_input_domains'],
        'new_domains_at_bind': !exists(json, 'new_domains_at_bind') ? undefined : json['new_domains_at_bind'],
    };
}

export function CRSFDomainExpansionTicketDataToJSON(value?: CRSFDomainExpansionTicketData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_removed_domains': value.account_removed_domains,
        'domain_confidence_list': CRSFZoomyDomainConfidenceMapListToJSON(value.domain_confidence_list),
        'domain_sources': value.domain_sources,
        'expansion_components': value.expansion_components,
        'high_confidence_domains': value.high_confidence_domains,
        'invalid_input_domains': value.invalid_input_domains,
        'new_domains_at_bind': value.new_domains_at_bind,
    };
}

